import { TerrainIcon } from './TerrainIcon';
import { TERRAIN_LABELS, TerrainType } from '@/lib/types/core/terrain';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

interface TerrainDisplayProps {
  terrains: TerrainType[];
  size?: number;
}

export const TerrainDisplay: React.FC<TerrainDisplayProps> = ({
  terrains,
  size = 18,
}) => {
  if (!terrains || terrains.length === 0) return null;

  return (
    <TooltipProvider>
      <div className="flex flex-wrap gap-1">
        {terrains.map(terrain => (
          <Tooltip key={terrain}>
            <TooltipTrigger asChild>
              <div className="p-1 rounded-full bg-adv-darkGray">
                <TerrainIcon terrain={terrain} size={size} className="text-adv-lightGray" />
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {TERRAIN_LABELS[terrain]}
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
};
